import React from 'react';
import { motion } from 'framer-motion';
import { Shield, MessageSquareX, Sun, EyeOff } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProtocolSection() {
  const pillars = [{
    icon: <Shield className="w-6 h-6" data-id="element-156" />,
    title: 'Cortar estímulos (sin drama)',
    desc: 'Silenciar, limpiar, poner fricción. No se trata de odiar. Se trata de sobrevivir.'
  }, {
    icon: <MessageSquareX className="w-6 h-6" data-id="element-157" />,
    title: 'Scripts Anti‑Impulso',
    desc: 'Qué decirte a ti. Qué responder si reaparece. Qué mandar a una amiga para que te sostenga. Sin improvisar.'
  }, {
    icon: <Sun className="w-6 h-6" data-id="element-158" />,
    title: 'Rutina de emergencia mañana/noche',
    desc: 'Para las dos puertas principales del bucle: despertar y madrugada.'
  }, {
    icon: <EyeOff className="w-6 h-6" data-id="element-159" />,
    title: 'Realidad en dosis',
    desc: 'Sin humillarte. Sin autoengaño. Para dejar de negociar con una fantasía.'
  }];
  return <section className="bg-[#0D0D0D] relative overflow-hidden" style={{
    paddingTop: 'var(--space-section-lg)',
    paddingBottom: 'var(--space-section-lg)',
    paddingLeft: 'var(--pad-x)',
    paddingRight: 'var(--pad-x)'
  }} data-id="element-160">
      {/* Background accent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#A52422]/5 blur-[100px] rounded-full pointer-events-none" data-id="element-161" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-163">
          <span className="text-[#A52422] font-bold tracking-widest uppercase mb-4 block fluid-sm" data-id="element-164">
            La Solución
          </span>
          <h2 className="fluid-4xl font-bold text-white mb-6 font-serif" data-id="element-165">
            Protocolo Anti‑Espiral (7 Días)
          </h2>
          <p className="fluid-lg text-[#9A948C] max-w-xl mx-auto" data-id="element-166">
            No es "contacto cero" como idea bonita. <br data-id="element-167" />
            Es contacto cero con instrucciones, por dentro y por fuera.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-168">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-[#141210] p-6 sm:p-8 rounded-xl border border-white/5 hover:border-[#A52422]/30 transition-colors group" data-id="element-169">
              <div className="w-12 h-12 bg-[#A52422]/10 rounded-lg flex items-center justify-center text-[#A52422] mb-6 group-hover:bg-[#A52422] group-hover:text-white transition-colors duration-300" data-id="element-170">
                {pillar.icon}
              </div>
              <h3 className="fluid-xl font-bold text-white mb-3 font-serif" data-id="element-171">
                {index + 1}. {pillar.title}
              </h3>
              <p className="text-[#9A948C] leading-relaxed fluid-base" data-id="element-172">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-173">
          <CTAButton data-id="element-174" />
        </div>
      </div>
    </section>;
}